module.exports = __webpack_public_path__ + "img/badge_on_demand.6ace1dfc.png";